import GlobalStyles from '@mui/material/GlobalStyles';
import { getMultiModalConfig } from 'shared/utils/multiModalConfig.js';

import {
  EnvName,
  envName,
} from '../../../env.js';
import {
  Banner,
  sandboxBannerGlobalStyles,
} from './SandboxBanner.styles.js';

const isSandbox = envName === EnvName.DEV || envName === EnvName.STAGING;

export const SandboxBanner = () => {
  if (!isSandbox) {
    return null;
  }

  const top = getMultiModalConfig()?.headerOffset ?? 0;

  return (
    <>
      <GlobalStyles styles={sandboxBannerGlobalStyles} />
      <Banner data-testid="sandbox-banner" data-sentry-unmask sx={{ top }}>
        <span>
          This is the SAFc Registry Sandbox environment - visit the production registry
          {' '}
          <a href="http://safcregistry.org">here</a>
        </span>
      </Banner>
    </>
  );
};
